
import React from 'react'
import { isEmpty } from '../../utils/validations'

import PropTypes from 'prop-types'
import Arrow from '../utils/Arrow'

const MostAccessedTable = ({data, translate, text}) => {

  const renderFuncionalities = () => {

  const funcionalities = data.map(mostAccess => mostAccess.funcionality)

  return funcionalities.map((func,idx) => <div key={`${func}-${idx}`}> <span>{idx + 1}º - {func}</span> </div>)
  }

  const renderAccess = () => data.map((data,index) => <div key={`${data.funcionality}-${index}`}> {data.access} </div>)

  const renderTendencies = () => {
    const tendencies = data.map(mostAccess => mostAccess.tendency)
    return tendencies.map((tend,idx) => <Arrow key={idx} value={tend} />)
  }
  const renderMostAcessed = () => {

  if(isEmpty(data)) return  <div className='new-analytics-no-data'><span >Sem dados</span> </div>

    return <div className='new-analytics-most-access'>
                <div className='new-analytics-funcionality'>
                    <div> <span style={{fontWeight: 600}}>{translate(text)}</span> </div>
                    {renderFuncionalities()}
                </div>
              <div className='new-analytics-most-access-right'>
                  <div className='new-analytics-access'>
                    <div> <span style={{fontWeight: 600}}>{translate('analytics.access')}</span> </div>
                    {renderAccess()}
                  </div>

                  <div className='new-analytics-tendencies'>
                    <span style={{fontWeight: 600}}>{translate('analytics.tendency')}</span>
                    {renderTendencies()}
                  </div>
                </div>
            </div>

  }

  return <div> {renderMostAcessed()} </div>
}

MostAccessedTable.propTypes = {
  data: PropTypes.array.isRequired,
  translate: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired
}
export default MostAccessedTable
